export default {
  'component.display.title': 'Visning',
  'component.display.description':
    'Her har du og over synspunkter. Hvis du vil at en megler skal se for deg, kan du bestille den ved å trykke på knappen nedenfor.',
  'component.display.addview': 'Legg til visning',
  'component.display.upcomingview': 'Kommende visninger',
  'component.display.completedview': 'Fullførte visninger',
  'component.display.modal.title': 'Utseende Tid',
};
